import { SvgIcon, SvgIconProps } from '@mui/material'

const JaryanIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 25 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clip-path="url(#clip0_635_672)">
        <path
          d="M12.5 5.5C13.4283 5.5 14.3185 5.86875 14.9749 6.52513C15.6313 7.1815 16 8.07174 16 9C16 9.92826 15.6313 10.8185 14.9749 11.4749C14.3185 12.1313 13.4283 12.5 12.5 12.5C11.5717 12.5 10.6815 12.1313 10.0251 11.4749C9.36875 10.8185 9 9.92826 9 9C9 8.07174 9.36875 7.1815 10.0251 6.52513C10.6815 5.86875 11.5717 5.5 12.5 5.5ZM5.5 8C6.06 8 6.58 8.15 7.03 8.42C6.88 9.85 7.3 11.27 8.16 12.38C7.66 13.34 6.66 14 5.5 14C4.70435 14 3.94129 13.6839 3.37868 13.1213C2.81607 12.5587 2.5 11.7956 2.5 11C2.5 10.2044 2.81607 9.44129 3.37868 8.87868C3.94129 8.31607 4.70435 8 5.5 8ZM19.5 8C20.2956 8 21.0587 8.31607 21.6213 8.87868C22.1839 9.44129 22.5 10.2044 22.5 11C22.5 11.7956 22.1839 12.5587 21.6213 13.1213C21.0587 13.6839 20.2956 14 19.5 14C18.34 14 17.34 13.34 16.84 12.38C17.7 11.27 18.12 9.85 17.97 8.42C18.42 8.15 18.94 8 19.5 8ZM6 18.25C6 16.18 8.91 14.5 12.5 14.5C16.09 14.5 19 16.18 19 18.25V20H6V18.25ZM0.5 20V18.5C0.5 17.11 2.39 15.94 4.95 15.6C4.36 16.28 4 17.22 4 18.25V20H0.5ZM24.5 20H21V18.25C21 17.22 20.64 16.28 20.05 15.6C22.61 15.94 24.5 17.11 24.5 18.5V20Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_635_672">
          <rect
            width="24"
            height="24"
            fill="currentColor"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </SvgIcon>
  )
}

export default JaryanIcon
